module.exports = __webpack_public_path__ + "img/player.a7ca46bf.svg";